/**
 * The selected range's collection window, for the hover cards that name its months.
 *
 * Its own context rather than a read of AppData, because `Info` sits under the
 * drill-through that AppData itself renders; importing AppData from there would be a
 * module cycle. AppDataProvider supplies it. Null outside the provider — a card then
 * says what the window is without naming months.
 */
import { createContext, useContext } from 'react'
import type { CollectionWindow } from '@/measures/collection'

export const CollectionWindowContext = createContext<CollectionWindow | null>(null)

export const useCollectionWindow = () => useContext(CollectionWindowContext)
